export function getQueryVariable(variable) {
  var query = window.location.href.split('?')[1]
  if (query) {
    var vars = query.split('&')
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=')
      if (pair[0] == variable) {
        return pair[1]
      }
    }
  }
  return ''
}

/**
 * 过滤主题活动
 * @param {Array} tree - 树状结构数组
 * @param {Function} predicate - 谓词函数，用于判断节点是否保留
 * @returns {Array} - 过滤后的树状结构数组
 * 示例：只保留 name 属性包含 "1" 的节点，filterTree(treeData, predicate);，其中predicate = node => node.name.includes('1');
 */
export function filterSectionActivity(tree, predicate) {
  return tree
    .map(node => {
      // 复制当前节点
      const newNode = { ...node };

      // 递归过滤子节点
      if (newNode.children && newNode.children.length > 0) {
        newNode.children = filterSectionActivity(newNode.children, predicate);

        // 如果子节点都被过滤掉了，则当前节点也应被过滤掉
        if (newNode.children.length === 0 && !predicate(newNode)) {
          return null;
        }
      }

      // 如果函数返回 false，则返回 null 以表示该节点应被过滤掉
      return predicate(newNode) ? newNode : null;
    })
    .filter(node => node !== null); // 移除所有被标记为 null 的节点
}

/**
 * 自定义树状结构
 * @param {Array} tree - 树状结构数组
 * @returns {Array} - 带有 parentId 属性的树状结构数组
 */
export function handleTreeData(tree, parentId = '0', checkCondition) {
  return tree.map(node => {
    // 复制当前节点并新增 parentId 属性
    const newNode = { ...node, parentId, checked: checkCondition(node), isItemIndeterminate: false, disabled: (!node.children || node?.children?.length === 0) && node.iscategory };

    // 如果节点有子节点，则递归地为子节点添加 parentId
    if (newNode.children && newNode.children.length > 0) {
      newNode.children = handleTreeData(newNode.children, newNode.id, checkCondition);
    }

    return newNode;
  });
}

/**
 * 将树状结构转换为一维数组
 * @param {Array} tree - 树状结构数组
 * @param {number|null} parentId - 用于根节点的父 ID，默认为 '0'
 * @returns {Array} - 一维数组，包含树中所有节点的信息
 */
export function flattenTree(tree) {
  let flatArray = [];

  tree.forEach(node => {
    // 创建节点的扁平化表示
    const flatNode = { ...node };
    delete flatNode.children;

    // 将当前节点添加到结果数组中
    flatArray.push(flatNode);

    // 如果节点有子节点，则递归地处理子节点
    if (node.children && node.children.length > 0) {
      flatArray = flatArray.concat(flattenTree(node.children, node.id));
    }
  });

  return flatArray;
}

/**
 * 下载文件
 * @param {Blob} data - 文件数据
 * @param {String} filename - 文件名
 */
export function downloadFile(data, filename) {
  console.log('data', data);
  const link = document.createElement("a");
  let blob = new Blob([data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });
  link.style.display = "none";
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  window.URL.revokeObjectURL(link.href);
  document.body.removeChild(link);
}
